var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$auth.ready())?_c('router-view'):_vm._e(),(!_vm.$auth.ready())?_c('div',{staticClass:"_init-spinner"},[_c('loading-spinner')],1):_vm._e(),_c('dialogs-wrapper',{attrs:{"transitionName":"fade"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }